"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const quizSessionIncludesModule_1 = __importDefault(require("./quizSessionIncludesModule"));
function updateQuizModulesStudied({ modulesStudied }, { session, modules }) {
    return (modulesStudied +
        modules.filter(module => (0, quizSessionIncludesModule_1.default)(session, module)).length);
}
exports.default = updateQuizModulesStudied;
